/* Caddie for Zanetta Sg: global behaviour. No dependencies.
   Drawers (menu, cart, search, quick add), the compacting header, the cart drawer through the
   Cart AJAX API + Section Rendering API, card swatches and quick add.
   Everything is progressive: without this file, forms post to /cart/add, the cart icon opens /cart,
   search opens /search and the menu opens as #MenuDrawer. */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {}, assets: {} };
  var S = T.strings || {};
  var R = T.routes || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fill(str, map) { return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var root = (R.root_url || '/').replace(/\/?$/, '/');
  function url(path) { return root + path.replace(/^\//, ''); }

  /* ---------- live region ---------- */
  var liveEl = $('[data-live]'), liveT;
  function announce(msg) {
    if (!liveEl) return;
    liveEl.textContent = '';
    clearTimeout(liveT);
    liveT = setTimeout(function () { liveEl.textContent = msg; }, 60);
  }

  /* ---------- remembered size (this browser only) ---------- */
  var SIZE_KEY = 'zanetta:size';
  var Size = {
    get: function () { try { return localStorage.getItem(SIZE_KEY) || ''; } catch (e) { return ''; } },
    set: function (v) { try { if (v) localStorage.setItem(SIZE_KEY, v); else localStorage.removeItem(SIZE_KEY); } catch (e) {} document.dispatchEvent(new CustomEvent('size:change', { detail: { size: v } })); }
  };

  /* ---------- shopper side (v1.3.0): women's or men's, for the product picks ----------
     From the collection in the page address (/collections/<handle>, and /collections/<handle>/products/...);
     a collection opened is remembered for this visit only (sessionStorage). Theme settings > Shopper side
     lists which collections count as each side. */
  var SIDE_KEY = 'zanetta:side';
  function sideOf(handle) {
    var out = '';
    (T.sides || []).forEach(function (s) { if (!out && s.h && (s.c || []).indexOf(handle) > -1) out = s.h; });
    return out;
  }
  var urlCol = (location.pathname.match(/\/collections\/([^\/]+)/) || [])[1];
  var urlSide = urlCol ? sideOf(decodeURIComponent(urlCol).toLowerCase()) : '';
  if (urlSide) { try { sessionStorage.setItem(SIDE_KEY, urlSide); } catch (e) {} }
  var Side = {
    get: function () { if (urlSide) return urlSide; try { return sessionStorage.getItem(SIDE_KEY) || ''; } catch (e) { return ''; } }
  };
  /* picks rendered for more than one side: show the shopper's list. The women's list is the one rendered
     visible, so it stays when the side is unknown and when JavaScript does not run. */
  function showSide(box) {
    var want = Side.get(); if (!want) return;
    var lists = $$('[data-side]', box);
    var match = lists.filter(function (l) { return l.getAttribute('data-side') === want; })[0];
    if (!match) return;
    lists.forEach(function (l) { l.hidden = l !== match; });
    box.setAttribute('data-side-shown', want);
  }
  $$('[data-picks-sides]').forEach(showSide);

  /* ---------- drawers: portal to body, inert background, focus kept inside, Esc and backdrop close ---------- */
  var FOCUSABLE = 'a[href]:not([tabindex="-1"]),button:not([disabled]):not([tabindex="-1"]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var stack = [];
  function visibleFocusables(el) { return $$(FOCUSABLE, el).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; }); }
  var Drawer = {
    open: function (el, trigger, focusEl) {
      if (!el) return;
      if (Drawer.isOpen(el)) { if (focusEl) focusEl.focus(); return; }
      if (el.parentNode !== document.body && !el.hasAttribute('data-no-portal')) document.body.appendChild(el);
      var entry = { el: el, trigger: trigger || document.activeElement, inerted: [] };
      /* make everything outside the drawer inert: the siblings of the drawer and of each of its ancestors */
      for (var n = el; n && n !== document.body; n = n.parentElement) {
        Array.prototype.forEach.call(n.parentElement ? n.parentElement.children : [], function (sib) {
          if (sib === n || sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE' || sib.inert) return;
          sib.inert = true; entry.inerted.push(sib);
        });
      }
      stack.push(entry);
      el.classList.add('is-open');
      document.documentElement.classList.add('has-drawer');
      $$('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      var target = focusEl || $('[data-autofocus]', el) || $('.drawer-title', el) || visibleFocusables(el)[0];
      if (target) { if (!target.hasAttribute('tabindex') && !target.matches(FOCUSABLE)) target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      el.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true }));
    },
    close: function (el, opts) {
      var i = -1;
      stack.forEach(function (e, n) { if (e.el === el) i = n; });
      if (i < 0) return;
      var entry = stack.splice(i, 1)[0];
      entry.inerted.forEach(function (n) { n.inert = false; });
      el.classList.remove('is-open');
      if (!stack.length) document.documentElement.classList.remove('has-drawer');
      $$('[aria-controls="' + el.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      if (!(opts && opts.noReturn) && entry.trigger && document.contains(entry.trigger)) entry.trigger.focus({ preventScroll: true });
      el.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true }));
      return entry.trigger;
    },
    top: function () { return stack.length ? stack[stack.length - 1].el : null; },
    isOpen: function (el) { return stack.some(function (e) { return e.el === el; }); },
    refocus: function () { var t = Drawer.top(); if (t && !t.contains(document.activeElement)) { var f = $('.drawer-title', t) || visibleFocusables(t)[0]; if (f) f.focus({ preventScroll: true }); } }
  };
  if (location.hash && /^#(MenuDrawer|CartDrawer|SearchDrawer|QuickAdd|Filters-[w-]+)$/.test(location.hash) && history.replaceState) {
    history.replaceState(null, '', location.pathname + location.search);
  }

  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { var d = closer.closest('[data-drawer]'); if (d) { e.preventDefault(); Drawer.close(d); } return; }
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); Drawer.open(document.getElementById(opener.getAttribute('data-drawer-open')), opener); }
  });
  document.addEventListener('keydown', function (e) {
    var top = Drawer.top();
    if (e.key === 'Escape') {
      if (top) { e.preventDefault(); Drawer.close(top); return; }
      $$('details[data-close-outside][open]').forEach(function (d) { d.removeAttribute('open'); var s = $('summary', d); if (s) s.focus(); });
      return;
    }
    if (e.key === 'Tab' && top) {
      var f = visibleFocusables(top); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !top.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !top.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header: desktop dropdowns, compact on scroll ---------- */
  document.addEventListener('click', function (e) {
    $$('details[data-close-outside][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  var head = $('[data-header]'), headSec = head && head.parentElement, ticking = false;
  function onScroll() {
    ticking = false;
    if (!headSec) return;
    var top = headSec.getBoundingClientRect().top;
    head.classList.toggle('is-stuck', top < -1 || (top <= 0 && window.scrollY > 40));
  }
  if (head) {
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }

  /* ---------- search: open the drawer, load search.js on first use ---------- */
  var searchLoaded = false;
  function openSearch(trigger) {
    var d = document.getElementById('SearchDrawer'); if (!d) return false;
    var menu = document.getElementById('MenuDrawer');
    if (menu && Drawer.isOpen(menu)) Drawer.close(menu, { noReturn: true });
    Drawer.open(d, trigger, $('[data-ps-input]', d));
    if (!searchLoaded && T.assets && T.assets.search) {
      searchLoaded = true;
      var s = document.createElement('script'); s.src = T.assets.search; s.defer = true; document.head.appendChild(s);
    }
    return true;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-open]');
    if (t && !document.body.classList.contains('t-search') && openSearch(t)) e.preventDefault();
  });

  /* ---------- cart: AJAX API + Section Rendering API ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var SECTION = 'cart-drawer';
  function sectionsUrl() { return location.pathname; }
  function renderCart(sections) {
    if (!sections || !sections[SECTION]) return;
    var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    var fresh = doc.getElementById('shopify-section-' + SECTION) || doc.body.firstElementChild;
    var cur = document.getElementById('shopify-section-' + SECTION);
    if (fresh && cur) cur.replaceWith(fresh);
    var inner = $('[data-cart-drawer-inner]');
    var count = inner ? parseInt(inner.getAttribute('data-count'), 10) || 0 : 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var ex = $('[data-cart-express]'); if (ex) ex.hidden = count === 0;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
  }
  function post(path, body, isForm) {
    var opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (isForm) { opts.body = body; }
    else { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    return fetch(path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) { var err = new Error(j.description || j.message || S.error); err.data = j; throw err; }
        return j;
      });
    });
  }
  var Cart = {
    add: function (data) {
      var isForm = typeof FormData !== 'undefined' && data instanceof FormData;
      if (isForm) { data.append('sections', SECTION); data.append('sections_url', sectionsUrl()); }
      else { data = Object.assign({ sections: SECTION, sections_url: sectionsUrl() }, data); }
      return post((R.cart_add_url || '/cart/add') + '.js', data, isForm).then(function (j) { renderCart(j.sections); return j; });
    },
    change: function (line, qty) {
      return post((R.cart_change_url || '/cart/change') + '.js', { line: line, quantity: qty, sections: SECTION, sections_url: sectionsUrl() })
        .then(function (j) { renderCart(j.sections); return j; });
    },
    open: function (trigger) {
      if (!cartDrawer) { location.href = R.cart_url || '/cart'; return; }
      Drawer.open(cartDrawer, trigger);
    },
    /* v1.5.0: what an add opens. Phones up to 600px: a small sheet with the pair just added (copied from
       its line in the re-rendered drawer), Check out and See your bag. Wider screens: the cart drawer. */
    after: function (trigger, variantId) {
      /* the line's words as a screen reader hears them: the visual dots dropped, the hidden commas kept */
      function plain(el) { var c = el.cloneNode(true); Array.prototype.forEach.call(c.querySelectorAll('[aria-hidden]'), function (n) { n.remove(); }); return c.textContent.replace(/\s+/g, ' ').replace(/ ,/g, ',').trim(); }
      var line = cartDrawer && variantId ? $('[data-variant-id="' + variantId + '"]', cartDrawer) : null;
      if (addedSheet && line && phoneMQ && phoneMQ.matches) {
        var box = $('[data-added-line]', addedSheet), img = $('.cd-img img', line), h = $('h3', line), meta = $('.meta', line), pr = $('.cd-price', line);
        box.innerHTML = '<span class="add-ph">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" width="66" height="88">' : '') + '</span>' +
          '<div><p class="add-t">' + esc(h ? h.textContent.trim() : '') + '</p>' + (meta ? '<p class="add-m">' + esc(plain(meta)) + '</p>' : '') +
          /* v1.7.0: the line's own price markup (from the theme's own section), so a discounted line keeps its
             hidden "Sale price" / "Regular price" labels hidden and its struck original price */
          (pr ? '<p class="price">' + pr.innerHTML.trim() + '</p>' : '') + '</div>';
        Drawer.open(addedSheet, trigger);
        return;
      }
      Cart.open(trigger);
    }
  };
  var addedSheet = document.getElementById('AddedSheet');
  var phoneMQ = window.matchMedia ? window.matchMedia('(max-width: 600px)') : null;
  function addedId(j, fallback) {
    var it = j && j.items && j.items[0] ? j.items[0] : j;
    return String((it && (it.variant_id || it.id)) || fallback || '');
  }
  if (addedSheet) addedSheet.addEventListener('click', function (e) {
    var b = e.target.closest('[data-added-bag]'); if (!b || !cartDrawer) return;
    e.preventDefault();
    var t = Drawer.close(addedSheet, { noReturn: true });
    Drawer.open(cartDrawer, t);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-open]');
    if (!t || !cartDrawer || document.body.classList.contains('t-cart')) return;
    e.preventDefault(); Cart.open(t);
  });

  /* quantity steppers, typed quantities and remove links inside the drawer */
  var busy = false;
  function lineOf(el) { var li = el.closest('[data-line]'); return li ? { li: li, n: parseInt(li.getAttribute('data-line'), 10), key: li.getAttribute('data-key') } : null; }
  function changeLine(L, qty, focusSel, msg) {
    if (busy) return; busy = true;
    var body = $('[data-cart-drawer-body]'); if (body) body.setAttribute('aria-busy', 'true');
    L.li.classList.add('is-busy');
    Cart.change(L.n, qty).then(function () {
      var again = $('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(L.key) : L.key) + '"]');
      var f = again && focusSel ? $(focusSel, again) : null;
      (f || $('.drawer-title', cartDrawer)).focus({ preventScroll: true });
      announce(msg || S.updated);
    }).catch(function (err) {
      L.li.classList.remove('is-busy');
      var box = $('[data-line-error]', L.li); if (box) box.textContent = err.message || S.error;
      var inp = $('[data-cart-qty-input]', L.li); if (inp) inp.value = inp.defaultValue;
    }).then(function () { busy = false; var b = $('[data-cart-drawer-body]'); if (b) b.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    if (!cartDrawer || !cartDrawer.contains(e.target)) return;
    var step = e.target.closest('[data-cart-qty]');
    if (step) {
      var L = lineOf(step), inp = $('[data-cart-qty-input]', L.li);
      var dir = parseInt(step.getAttribute('data-cart-qty'), 10);
      var next = Math.max(0, (parseInt(inp.value, 10) || 0) + dir);
      var title = $('h3', L.li).textContent.trim();
      changeLine(L, next, '[data-cart-qty="' + dir + '"]', next === 0 ? fill(S.removed, { title: title }) : null);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var L2 = lineOf(rm);
      changeLine(L2, 0, null, fill(S.removed, { title: $('h3', L2.li).textContent.trim() }));
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-cart-qty-input]');
    if (!inp || !cartDrawer || !cartDrawer.contains(inp)) return;
    var q = Math.max(0, parseInt(inp.value, 10) || 0);
    changeLine(lineOf(inp), q, '[data-cart-qty-input]');
  });

  /* ---------- card data ---------- */
  function scopeOf(el) { return el.closest('[data-card],[data-qa-scope]'); }
  function dataOf(scope) {
    if (!scope) return null;
    if (scope._pd) return scope._pd;
    var s = $('[data-product-json]', scope); if (!s) return null;
    try { scope._pd = JSON.parse(s.textContent); } catch (e) { return null; }
    return scope._pd;
  }
  function valuesAt(pd, i) { var seen = [], out = []; pd.v.forEach(function (v) { var x = v.o[i]; if (seen.indexOf(x) < 0) { seen.push(x); out.push(x); } }); return out; }
  function variantFor(pd, colour, size) {
    return pd.v.filter(function (v) {
      return (pd.ci < 0 || colour == null || v.o[pd.ci] === colour) && (pd.si < 0 || size == null || v.o[pd.si] === size);
    });
  }

  /* swap a card photo once the new one has decoded, so it never flashes blank */
  function swapImg(img, entry) {
    if (!img || !entry) return;
    var n = new Image(); n.sizes = img.sizes; n.srcset = entry.set; n.src = entry.src;
    var done = function () { img.srcset = entry.set; img.src = entry.src; img.alt = entry.alt || img.alt; };
    if (n.decode) n.decode().then(done, done); else done();
  }

  /* swatches: swap the card photo and point the card link at that colour */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.sw[data-sw]'); if (!sw) return;
    var card = sw.closest('[data-card]'), pd = dataOf(card);
    $$('.sw', card).forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
    card.setAttribute('data-colour', sw.getAttribute('data-sw'));
    card.classList.add('has-colour');
    if (pd) {
      var mid = sw.getAttribute('data-media');
      if (mid && pd.img[mid]) swapImg($('.card-img-1', card), pd.img[mid]);
      var list = variantFor(pd, sw.getAttribute('data-sw'), null);
      var pick = list.filter(function (v) { return v.a; })[0] || list[0];
      if (pick) $$('[data-card-link]', card).forEach(function (a) { a.href = pd.url + (pd.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + pick.id; });
    }
  });

  /* v1.10.1 (JJ, 2026-10-06): no remembered-size "in stock" line on cards; this only clears the line
     (the collection size filter writes it, and resets through cards:added) */
  function markFit() {
    $$('[data-card]').forEach(function (card) {
      var fit = $('[data-fit]', card); if (!fit || card.closest('[data-pick]')) return;
      fit.textContent = '';
    });
  }
  markFit(Size.get());
  document.addEventListener('size:change', function (e) { markFit(e.detail.size); });
  document.addEventListener('cards:added', function () { markFit(Size.get()); });

  /* ---------- quick add sheet ---------- */
  var qa = document.getElementById('QuickAdd');
  var qaState = null;
  function qaRender() {
    var st = qaState, pd = st.pd, body = $('[data-qa-body]', qa);
    var colours = pd.ci > -1 ? valuesAt(pd, pd.ci) : [];
    var sizes = pd.si > -1 ? valuesAt(pd, pd.si) : [];
    var inColour = variantFor(pd, st.colour, null);
    var shown = inColour.filter(function (v) { return v.m && pd.img[v.m]; })[0];
    var img = shown ? pd.img[shown.m] : null;
    var price = (inColour[0] || pd.v[0]).p;
    var h = '<div class="qa-top">';
    var thumb = img ? img.thumb : pd.f; /* v1.4.0: the product's own photo when the variant has none */
    h += '<span class="qa-thumb">' + (thumb ? '<img src="' + esc(thumb) + '" alt="" width="80" height="80">' : '') + '</span>';
    h += '<div><p class="price">' + esc(price) + '</p><a class="link" href="' + esc(pd.url) + '">' + esc(S.full_details) + '</a></div></div>';
    if (colours.length > 1) {
      h += '<div class="qa-group" role="group" aria-labelledby="QaColour"><p class="qa-legend" id="QaColour">' + esc(S.colour) + ': <b>' + esc(st.colour) + '</b></p><div class="qa-colours">';
      colours.forEach(function (c) {
        var vs = variantFor(pd, c, null), any = vs.some(function (v) { return v.a; });
        var m = vs.filter(function (v) { return v.m && pd.img[v.m]; })[0];
        h += '<button type="button" class="qa-colour' + (any ? '' : ' is-out') + '" data-qa-colour="' + esc(c) + '" aria-pressed="' + (c === st.colour) + '">' +
          (m ? '<img src="' + esc(pd.img[m.m].thumb) + '" alt="" width="32" height="32">' : '') + '<span>' + esc(c) + (any ? '' : '<span class="sr">, ' + esc(S.sold_out) + '</span>') + '</span></button>';
      });
      h += '</div></div>';
    }
    if (sizes.length) {
      h += '<div class="qa-group" role="group" aria-labelledby="QaSize"><p class="qa-legend" id="QaSize">' + esc(S.choose_size_to_add) + '</p><div class="qa-sizes">';
      var mine = Size.get();
      sizes.forEach(function (s) {
        var v = variantFor(pd, st.colour, s)[0], ok = !!(v && v.a);
        h += '<button type="button" class="size-chip' + (ok ? '' : ' is-out') + (s === mine ? ' is-mine' : '') + '" data-qa-size="' + esc(s) + '"' +
          (v ? ' data-variant="' + v.id + '"' : '') + (ok ? '' : ' aria-disabled="true"') + '>' + esc(s) +
          (ok ? '' : '<span class="sr">, ' + esc(S.sold_out) + '</span>') + '</button>';
      });
      h += '</div></div>';
    } else {
      var only = inColour.filter(function (v) { return v.a; })[0];
      h += only ? '<button type="button" class="btn btn-ink btn-wide" data-variant="' + only.id + '" data-qa-add>' + esc(S.add) + '</button>'
        : '<p>' + esc(S.sold_out) + '</p>';
    }
    h += '<p class="qa-msg" data-qa-msg role="status"></p>';
    body.innerHTML = h;
    $('[data-qa-title]', qa).textContent = pd.title;
  }
  function openQuickAdd(trigger) {
    var scope = scopeOf(trigger), pd = dataOf(scope);
    if (!pd || !qa) { var a = scope && $('a[href]', scope); if (a) location.href = a.href; return; }
    if (pd.options.length > 2 || (pd.options.length === 2 && (pd.ci < 0 || pd.si < 0))) { location.href = pd.url; return; }
    var colours = pd.ci > -1 ? valuesAt(pd, pd.ci) : [];
    var want = scope.getAttribute('data-colour');
    if (!want || colours.indexOf(want) < 0) {
      var firstAvail = pd.v.filter(function (v) { return v.a; })[0] || pd.v[0];
      want = pd.ci > -1 ? firstAvail.o[pd.ci] : null;
    }
    qaState = { pd: pd, colour: want, scope: scope };
    qaRender();
    Drawer.open(qa, trigger);
  }
  function addVariant(btn, id, label) {
    var msg = $('[data-qa-msg]', qa);
    btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy');
    if (msg) msg.textContent = S.adding + '...';
    return Cart.add({ items: [{ id: id, quantity: 1 }] }).then(function (j) {
      var trigger = Drawer.close(qa, { noReturn: true });
      Cart.after(trigger, addedId(j, id));
      announce(fill(S.added, { title: label }));
    }).catch(function (err) {
      btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy');
      if (msg) msg.textContent = err.message || S.error;
    });
  }
  if (qa) {
    qa.addEventListener('click', function (e) {
      if (!qaState) return;
      var pd = qaState.pd, msg = $('[data-qa-msg]', qa);
      var c = e.target.closest('[data-qa-colour]');
      if (c) {
        qaState.colour = c.getAttribute('data-qa-colour');
        qaRender();
        var again = $('[data-qa-colour="' + (window.CSS && CSS.escape ? CSS.escape(qaState.colour) : qaState.colour) + '"]', qa); if (again) again.focus();
        var sw = qaState.scope && $('.sw[data-sw="' + (window.CSS && CSS.escape ? CSS.escape(qaState.colour) : qaState.colour) + '"]', qaState.scope);
        if (sw) sw.click();
        var allOut = !variantFor(pd, qaState.colour, null).some(function (v) { return v.a; });
        $('[data-qa-msg]', qa).textContent = allOut ? fill(S.colour_sold_out, { colour: qaState.colour }) : '';
        return;
      }
      var s = e.target.closest('[data-qa-size]');
      if (s) {
        var size = s.getAttribute('data-qa-size');
        if (s.getAttribute('aria-disabled') === 'true') { msg.textContent = fill(S.size_sold_out_msg, { size: size, colour: qaState.colour || '' }).replace(/ in \./, '.'); return; }
        if (s.getAttribute('aria-busy') === 'true') return;
        Size.set(size);
        addVariant(s, parseInt(s.getAttribute('data-variant'), 10), pd.title + ', ' + [qaState.colour, size].filter(Boolean).join(' / '));
        return;
      }
      var add = e.target.closest('[data-qa-add]');
      if (add) addVariant(add, parseInt(add.getAttribute('data-variant'), 10), pd.title + (qaState.colour ? ', ' + qaState.colour : ''));
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-add-open]'); if (!t) return;
    e.preventDefault(); openQuickAdd(t);
  });

  /* ---------- product recommendations (lazy) ---------- */
  $$('[data-recs]').forEach(function (el) {
    var u = el.getAttribute('data-url'); if (!u || !window.fetch) return;
    fetch(u).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = new DOMParser().parseFromString(html, 'text/html');
      var inner = tmp.querySelector('[data-recs]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; document.dispatchEvent(new CustomEvent('cards:added')); }
    }).catch(function () {});
  });

  /* ---------- money in the store's own format (v1.7.0) ----------
     Liquid prints 100000 cents through the store's money format (theme.money, for example "$1,000.00 SGD");
     the separators and the text around the number are read from that sample. */
  function money(c) {
    var s = T.money || '', v = Math.round(+c || 0), n = Math.abs(v), neg = v < 0 ? '-' : '';
    var m = s.match(/1([^\d]?)000(?:([^\d])00)?/);
    if (!m) return neg + (n / 100).toFixed(2);
    var whole = m[2] ? Math.floor(n / 100) : Math.round(n / 100);
    var txt = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[1] || '');
    if (m[2]) txt += m[2] + ('0' + (n % 100)).slice(-2);
    return neg + s.replace(m[0], txt);
  }

  /* ---------- pair offer (v1.7.0) ----------
     The theme only SHOWS the offer; two automatic discounts in Shopify admin make it. In the bag, the saving is
     what Shopify applied, read from /cart.js (total_discount, else the sum of cart_level_discount_applications
     and each line's discount_allocations), never worked out here. A pair = the quantity of a line that ships,
     is not a gift card and has a size option (the "Digital Product" placeholder ships nothing and has none). */
  var OF = T.offer || {};
  var Offer = {
    on: !!(OF.on && OF.p2 > 0 && OF.n2 > 1),
    /* integer cents: the saving rounded to the nearest cent (half up); what you pay = the full price less it */
    tier: function (price, qty, pct) {
      var full = Math.round(+price || 0) * qty, save = Math.floor((full * pct + 50) / 100);
      return { full: full, save: save, pay: full - save };
    },
    isPair: function (it) {
      return !it.gift_card && it.requires_shipping !== false && (it.options_with_values || []).some(function (o) { return /size/i.test(o && o.name); });
    },
    pairs: function (cart) {
      return (cart.items || []).reduce(function (n, it) { return n + (Offer.isPair(it) ? (+it.quantity || 0) : 0); }, 0);
    },
    saving: function (cart) {
      if (typeof cart.total_discount === 'number') return cart.total_discount;
      var s = 0;
      (cart.cart_level_discount_applications || []).forEach(function (d) { s += +d.total_allocated_amount || 0; });
      (cart.items || []).forEach(function (it) { (it.discount_allocations || []).forEach(function (d) { s += +d.amount || 0; }); });
      return s;
    },
    cache: null,
    seq: 0,
    paint: function (cart) {
      if (!Offer.on) return;
      if (cart) Offer.cache = cart;
      cart = Offer.cache; if (!cart) return;
      var save = Offer.saving(cart), pairs = Offer.pairs(cart), h = '';
      if (save > 0) h += '<p class="offer-save">' + fill(esc(S.offer_saving), { amount: '<b>' + esc(money(save)) + '</b>' }) + '</p>';
      if (pairs > 0 && pairs < OF.n2) {
        var need = OF.n2 - pairs;
        h += '<p class="offer-nudge">' + esc(fill(need === 1 ? S.offer_nudge_one : S.offer_nudge_other, { count: need, pct: OF.p2 })) + '</p>';
      }
      $$('[data-offer-bag]').forEach(function (el) { el.innerHTML = h; el.hidden = !h; });
    },
    refresh: function () {
      if (!Offer.on || !window.fetch) return;
      var mine = ++Offer.seq;
      fetch((R.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (mine === Offer.seq) Offer.paint(c); })
        .catch(function () {});
    }
  };
  if (Offer.on) {
    /* a re-rendered drawer starts empty: show the last known lines at once, then read the bag again */
    document.addEventListener('cart:updated', function () { Offer.paint(); Offer.refresh(); });
    document.addEventListener('drawer:open', function (e) { if (e.target === cartDrawer && !Offer.cache) Offer.refresh(); });
    if (document.body.classList.contains('t-cart') && $('[data-offer-bag]')) Offer.refresh();
  }

  window.ZT = { $: $, $$: $$, fill: fill, esc: esc, url: url, announce: announce, money: money, Offer: Offer, Size: Size, Side: Side, Drawer: Drawer, Cart: Cart, openSearch: openSearch, addedId: addedId };
  document.dispatchEvent(new CustomEvent('zt:ready'));
})();
